import { Entity } from "../../Entity";
import TaskTemplateFactory from "../../Factories/TaskTemplateFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { TaskTemplateInterface } from "./TaskTemplateInterface";

class TaskTemplate extends Entity implements TaskTemplateInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return TaskTemplateFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get name(): string {
    return this.data.name;
  }

  get details(): string | null {
    return this.data.details;
  }

  get executorId(): number {
    return this.data.executorId;
  }

  get daysToExecute(): number | null {
    return this.data.daysToExecute;
  }

  get activityTemplateId(): number {
    return this.data.activityTemplateId;
  }

  get removed(): boolean {
    return this.data.removed;
  }
}

export { TaskTemplate };
